import { SSMResponseProductLicense } from 'models'
import { CostDistribution } from '../securityStackMap.utils'
import { CustomVendorFormData, FormData } from './SSMDrawer'

export const getUTCYear = (dateString: string): number => new Date(dateString).getUTCFullYear()

export const emptyVendorValue = {
  display_name: '',
  uuid: '',
  logo_path: '',
  name: '',
  url: '',
  created_at: '',
  created_by: null,
  description: '',
  is_product: false,
  tenant_id: null,
  vendor_uuid: '',
  verified: false
}

export const initialFormData: FormData = {
  perYear: [
    {
      licenseCost: 0,
      numberOfLicenses: 0,
      year: new Date().getFullYear()
    }
  ],
  pricingUnits: undefined,
  note: undefined,
  startDate: undefined,
  endDate: undefined
}

export const initialCustomVendorFormData: CustomVendorFormData = {
  vendorName: undefined,
  productName: undefined,
  perYear: [
    {
      licenseCost: 0,
      numberOfLicenses: 0,
      year: new Date().getFullYear()
    }
  ],
  pricingUnits: undefined,
  note: undefined,
  startDate: undefined,
  endDate: undefined
}

// Only an explicit is_auto === false means a manual split was ever stored; products without
// license data have none, and inferring one makes the save send an empty distribution.
export const getCostDistribution = (license?: SSMResponseProductLicense | null): CostDistribution =>
  license?.is_auto === false ? CostDistribution.Manual : CostDistribution.Even

export const buildCellsPayload = (costDistribution: CostDistribution, fields?: any[]) => {
  if (costDistribution !== CostDistribution.Manual || !fields || fields.length === 0) return undefined

  const cells = fields.map((field) => ({
    nist: field.nist.toLowerCase(),
    asset: field.asset.toLowerCase(),
    costBps: Math.round((field.value ?? 0) * 100)
  }))

  // An all-zero split is not a distribution the API accepts — omit it and let the backend spread the cost.
  return cells.some((cell) => cell.costBps > 0) ? cells : undefined
}

// The SSM cell endpoints return nist/asset lowercase while the grid uses the capitalized enums.
export const capitalizeCellSegment = (segment: string): string =>
  segment ? segment.trim().charAt(0).toUpperCase() + segment.trim().slice(1).toLowerCase() : segment

const sameSegment = (a: string, b: string) => a.trim().toLowerCase() === b.trim().toLowerCase()

// Compared case-insensitively so a cell coming straight from the API still matches the open grid cell.
export const isCurrentCell = (
  nist?: string | null,
  asset?: string | null,
  currentNist?: string | null,
  currentAsset?: string | null
): boolean =>
  !!nist &&
  !!asset &&
  !!currentNist &&
  !!currentAsset &&
  sameSegment(nist, currentNist) &&
  sameSegment(asset, currentAsset)
